var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92875 1L5.63856 1C4.40976 1 3.22046 1.50948 2.34833 2.44369C1.4762 3.37791 0.980705 4.6305 1.00058 5.96813C0.980652 7.30574 1.47634 8.55851 2.34833 9.49257C3.24021 10.4479 4.38982 10.9576 5.61867 10.9576H8.90885M13.0713 11H16.3614C17.5902 11 18.7795 10.4905 19.6517 9.55631C20.5238 8.62209 21.0193 7.3695 20.9994 6.03187C20.9994 4.7156 20.5039 3.46295 19.6318 2.52873C18.7596 1.59452 17.5903 1.06375 16.3614 1.06374H13.0713M6.05463 5.95356L15.9252 5.95356",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.5acdbd78e8f2c2b1cdf3783cfc1c88e5.svg";
export { ForwardRef as ReactComponent };